/** Explicit choice, otherwise browser language order, otherwise English. No auth state is changed. */
export class PurlivoLocale {
    static readonly supported = ["en", "en-GB", "ar", "de", "es", "es-MX", "fr", "it", "nl", "pt-BR", "ru", "th", "tr", "vi", "zh-Hans"];
    static resolve(languages: readonly string[]): string {
        for (const value of languages) {
            const candidate = value.trim().replace(/_/g, '-').toLowerCase();
            if (candidate === 'zh-cn' || candidate === 'zh-sg') return 'zh-Hans';
            const exact = this.supported.find(x => x.toLowerCase() === candidate);
            if (exact) return exact;
            const base = candidate.split('-')[0];
            const generic = this.supported.find(x => x.toLowerCase() === base);
            if (generic) return generic;
        }
        return 'en';
    }
    static requestLanguage(): string {
        const selected = abp.utils.getCookieValue('Abp.Localization.CultureName');
        const valid = this.supported.find(x => x.toLowerCase() === selected?.toLowerCase());
        return valid ?? this.resolve(navigator.languages?.length ? navigator.languages : [navigator.language]);
    }
}
